//@author: Augusto Monteiro


Greenmile.Route = Greenmile.Route || {};

Greenmile.Route.AssignHelper = function () {

    this.modalForm = null;
    this.availableToAssignHelpersRouteStatus = [
        'NOT_STARTED', 
        'DEPARTED_ORIGIN',
        'IN_PROGRESS', 
        'STARTED'
    ];

    this.isValidStatus = routeStatus => 
        this.availableToAssignHelpersRouteStatus.includes(routeStatus);

    this.getRouteStatus = () => App.Forms.Route.form.getModel().get("status");

    this.showAssignHelper = function () {

        this.modalForm.showModalForm();

    };

    this.addFormToModalContent = function () {

        var modalContent = document.querySelector("#Route .popupFormContainer");

        if (modalContent) {

            try {

                var routeId = App.Forms.Route.form.fields.id.getValue();
                var assignHelper = new Greenmile.Route.AssignHelper();
                var contentToModal = assignHelper.constructFormAssignHelper(routeId);
                var lookupContainer;

                modalContent.appendChild(contentToModal.html);

                lookupContainer = modalContent.querySelector('.form-horizontal');

                lookupContainer.appendChild(contentToModal.field.rootEl);

                assignHelper.populateListHelpers(routeId, contentToModal.field);
                assignHelper.addEventListenners();

            } catch (e) {

                var error = new Monet.Exception.ReturnError(this, "No add form to modal.");
                error.console();

            }


        } else {

            var exception = new Monet.Exception.ReturnError(this, "No modal to add form.");
            exception.console();

        }

    };

    this.buildTemplate = function (routeIdValue) {
        var layout = {
            "items": [
                {
                    "tag": "form",
                    "items": [
                        {
                            "items": [
                                {
                                    "items": [
                                        {
                                            "tag": "input",
                                            "attributes": {
                                                "type": "button",
                                                "value": Monet.I18n.getResourcesByKey("Route.AssingHelper.btnSave"),
                                                "name": "btn_save_assign_helper",
                                                "id": "btn_save_assign_helper",
                                                "class": "btn",
                                                "style": "float:right;",
                                            }
                                        },
                                        {
                                            "tag": "input",
                                            "attributes": {
                                                "type": "button",
                                                "value": Monet.I18n.getResourcesByKey("Route.AssingHelper.btnExit"),
                                                "name": "btn_exit_assign_helper",
                                                "id": "btn_exit_assign_helper",
                                                "class": "btn"
                                            }
                                        }
                                    ],
                                    "attributes": {
                                        "style": "position:relative; float:left; width: 100%",
                                        "class": "standard-form-buttons"
                                    }
                                },
                                {
                                    "items": [
                                        {
                                            "attributes": {
                                                "class": "monetInlineAlerContainer"
                                            }
                                        },
                                        {
                                            "tag": "input",
                                            "attributes": {
                                                "type": "hidden",
                                                "id": "route_id",
                                                "name": "route.id",
                                                "value": routeIdValue,
                                                "class": "modelAttribute"
                                            }
                                        }
                                    ],
                                    "attributes": {
                                        "class": "span8"
                                    }
                                }
                            ],
                            "attributes": {
                                "class": "row"
                            }
                        },
                        {
                            "items": [
                                {
                                    "items": [
                                        {
                                            "html": "",
                                            "attributes": {
                                                "class": "form-horizontal"
                                            }
                                        }
                                    ],
                                    "attributes": {
                                        "class": "span4"
                                    }
                                }
                            ],
                            "attributes": {
                                "class": "row"
                            }
                        }
                    ],
                    "attributes": {
                        "id": "form_assign_helper"
                    }
                }
            ]
        };

        return ( new Monet.UI.LayoutGenerator(layout) ).render();

    };

    this.constructFormAssignHelper = function (routeId) {

        try {

            var field = new Monet.UI.Fields.PowerLookupList();

            field.setId('driver');
            field.setNameSpace('driver');
            field.setLookUpEntity('Driver');
            field.setDisplayKey('name');
            field.setTextLabel(Monet.I18n.getResourcesByKey('Route.AssingHelper.label.driver'));
            field.setInputName('name');
            field.customCriteriaChain = [{
                attr: "driverType",
                eq: "HELPER"
            }];
            field.render();

            return {
                html: this.buildTemplate(routeId),
                field: field
            };

        } catch (e) {
            var error = new Monet.Exception.ReturnError(this, "No form to assign helpers.");
            error.console();
        }

    };

    this.appendLoading = function () {

        const loading = document.createElement('div');
        const iconImg = document.createElement('img');

        loading.className = 'loadingPopupFormContainer';
        iconImg.src = require("static/images/general/loading_blue.svg");
        loading.appendChild(iconImg);

        return loading;
    };

    this.loadingLookupItem = function () {
        var loadingImg = document.createElement('img');
        loadingImg.className = "loading_img loadingLookupItem";
        loadingImg.setAttribute('src', require("static/images/general/loading_blue.svg"));

        return loadingImg;
    };

    this.populateListHelpers = function (routeId, lookupField) {
        try {

            const route = new App.Routers.Route();
            const dataToLookup = [];
            const helpersList = document.querySelector('.container_lookuplist_added');
            helpersList.appendChild(this.appendLoading());

            const success = (helpers) => {
                var helpersTotal = helpers.length;

                if (helpersTotal) {
                    for (var i = 0; i < helpersTotal; i++) {
                        dataToLookup.push(helpers[i].helper);
                    }
                }

                lookupField.setValue(dataToLookup);
                helpers.forEach(helperData => {
                    const lookupItem = document.querySelector('.item_lookuplist_driver_' + helperData.helper.id);

                    if (lookupItem) {
                        const oldIconDestroy = lookupItem.querySelector('.del_item_added');

                        if (oldIconDestroy) {
                            oldIconDestroy.parentNode.removeChild(oldIconDestroy);
                            const iconDestroy = document.createElement('div');
                            iconDestroy.className = 'del_item_added';
    
                            const link = document.createElement('div');
                            link.className = 'table-action-destroylink';
                            link.innerHTML = '&nbsp;';

                            iconDestroy.appendChild(link);
                            lookupItem.insertBefore(this.loadingLookupItem(), lookupItem.firstChild);
                            lookupItem.insertBefore(iconDestroy, lookupItem.firstChild);

                            iconDestroy.addEventListener('click', () => {
                                $(lookupItem).find('.del_item_added').hide();
                                $(lookupItem).find('.loadingLookupItem').show();

                                const validateSuccess = (isValid) => {
                                    if (isValid) {
                                        lookupField.destroyItem(lookupItem);
                                        const model = new App.Models.RouteHelperAssignment();
                                        model.unassignToRoute({ assignmentId: helperData.id });
                                    }
                                    else {
                                        $(lookupItem).find('.loadingLookupItem').hide();
                                        $(lookupItem).find('.del_item_added').show();
                                    }
                                };

                                const validateError = () => {
                                    $(lookupItem).find('.loadingLookupItem').hide();
                                    $(lookupItem).find('.del_item_added').show();
                                };

                                this.validateRouteStatus(validateSuccess, validateError);
                            });
                        } 
                    }
                });

                $('.loadingPopupFormContainer').remove();
                
                const selectedRouteStatus = this.getRouteStatus();
                const shouldHide = !this.isValidStatus(selectedRouteStatus);

                const utils = new Greenmile.Route.ModalUtils();
                utils.removeAllActionListener(lookupField, helpers, 'helper', shouldHide);
            }

            const error = () => {
                const error = new Monet.Exception.ReturnError(this, "Could not get route helpers.");
                error.console();
                $('.loadingPopupFormContainer').remove();
            };

            route.getHelpersByRoute(routeId, success, error);

        } catch (e) {
            var error = new Monet.Exception.ReturnError(this, "No populate list drivers.");
            error.console();
        }
    };

    this.addEventListenners = function () {

        try {

            const that = this;

            const btnSave    = document.querySelector("#form_assign_helper #btn_save_assign_helper");
            const btnExit    = document.querySelector("#form_assign_helper #btn_exit_assign_helper");
            const btnClose   = document.querySelector('#Route .closeModalWindow');
            const formHelper = document.getElementById('form_assign_helper');

            const selectedRouteStatus = this.getRouteStatus();

            if (this.isValidStatus(selectedRouteStatus)) {

                btnSave.onclick = function () {
                    const route = new App.Routers.Route();
                    route.assignHelperToRoute();
                };
            } else {
                formHelper.setAttribute('disabled', 'true');
                btnSave.setAttribute("disabled", "disabled");
            }

            const checkHasHelperAndClose = () => {
                const hasHelperCheckbox = document.querySelector('#hasHelper');
                const hasHelpers = document.querySelector('#driver_list .title_item_added');

                that.modalForm.closeModalWindow();

                if (!hasHelpers && hasHelperCheckbox.disabled) {
                    hasHelperCheckbox.disabled = false;
                }
            };

            btnExit.onclick = checkHasHelperAndClose;
            btnClose.onclick = checkHasHelperAndClose;

        } catch (e) {
            new Monet.Exception
                .ReturnError(this, "No add event listenner to form.")
                .console();

        }

    };

    this.validateForm = function () {

        let isValid = true;

        try {

            const fields = document.querySelectorAll("#form_assign_helper #driver_list input[type='hidden']");

            if (!fields.length) {
                isValid = false;
            }

        } catch (e) {

            const error = new Monet.Exception.ReturnError(this, "No validate form.");
            error.console();

        }

        return isValid;
    };

    this.validateRouteStatus = function (successCallback, errorCallback) {
        let isValid = true;

        try {
            const routeStatusSuccess = (routeStatus) => {
                if (!this.isValidStatus(routeStatus)) {
                    isValid = false;
    
                    const errorMessages = { 
                        errorMessages: [
                            Monet.Form.Messages.mountErrorMessageObject('Route.AssignHelper.routeStartedError')
                        ] 
                    };

                    const monetMessage = new Monet.Form.Messages.InlineMessage();
    
                    monetMessage.setScope("#form_assign_helper");
                    monetMessage.setInfoType("error");
                    monetMessage.setMessage(errorMessages);
                    monetMessage.triggerMessage();
                }

                successCallback && successCallback(isValid);
            }

            const routeStatusError = data => errorCallback && errorCallback(data);

            new App.Routers.Route().getRouteStatus(routeStatusSuccess, routeStatusError);

        } catch (e) {
            new Monet.Exception
                .ReturnError(this, "Couldn't validate route status.")
                .console();
        }

        return isValid;
    }

    var init = function (scope) {
        return function (scope) {
            const selector = "#Route #form_and_grid";
            const scopeBlock = "#Route form.MonetUIForm.Route";
            const options = { width: 500, height: 400 };
            const callbacks = {
                onAfterShowModalForm: scope.addFormToModalContent
            };
            scope.modalForm = new Monet.Form.Modal(selector, options, callbacks, scopeBlock);
        }(scope);
    };

    init(this);

};
